import JavaScriptVersioned from "./javascript-versioned.mdx";
import JavaScriptVersionless from "./javascript-versionless.mdx";

{props.usesVersionlessApi ? (
  <JavaScriptVersionless {...props} />
) : (
  <JavaScriptVersioned {...props} />
)}
